<template>
  <aside class="app-sidebar">
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      :router="true"
      @open="handleOpen"
      @close="handleClose">
      <el-menu-item-group title="Usuarios">
        <el-menu-item v-if="userIsType('admin')" index="/admin">
          Administradores Minsal
        </el-menu-item>
        <el-menu-item v-if="userIsType('admin')" index="/medical-centers">
          Generadores de folios
        </el-menu-item>
        <el-menu-item-group>
          <template slot="title">
            Validadores
          </template>
          <el-menu-item v-if="userIsType('admin|dispenser_admin')" index="/dispensers-admin">
            Químico farmacéuticos
          </el-menu-item>
          <el-menu-item v-if="userIsType('admin|dispenser_admin')" index="/dispensers">
            Auxiliares de Farmacia
          </el-menu-item>
          <el-menu-item v-if="userIsType('admin')" index="/import-users">
            Importación masiva
          </el-menu-item>
        </el-menu-item-group>
      </el-menu-item-group>
      <el-menu-item-group v-if="userIsType('admin|dispenser_admin')" index="organizations-root">
        <template slot="title">
          Organizaciones
        </template>
        <el-menu-item v-if="userIsType('admin')" index="/organizations/medical-centers">
          Administrar Centros Médicos
        </el-menu-item>
        <el-menu-item v-if="userIsType('admin|dispenser_admin')" index="/organizations/pharmacies">
          Ver Farmacias (Midas)
        </el-menu-item>
      </el-menu-item-group>
    </el-menu>
    <div class="app-sidebar__menu list-group" />
  </aside>
</template>

<script>
export default {
  name: 'AppSidebar',
  methods: {
    userIsType(userRole) {
      return this.$store.getters.hasRole(userRole);
    },
    handleClose() {},
    handleOpen() {}
  }
};
</script>

<style lang="scss">
.app-sidebar {
  h4 {
    margin: $--spacing-6;
    font-size: 1rem;
  }

  .el-menu {
    color: $--color-white;
    min-height: 100vh;
    background: $--color-dark-blue;
  }

  .el-menu-item-group__title {
    font-weight: $--font-weight-bold;
    font-size: $--font-size-base;
    color: $--color-white;
  }

  .el-menu-item {
    color: $--color-white;

    &.is-active,
    &:hover {
      background: $--color-bright-blue;
    }
  }

  .el-menu-item-group {
    .el-menu-item-group {
      padding-left: $--spacing-4;
    }
  }
}
</style>
